import React from 'react'

import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { Form } from '../../../../components/ui/form'
import useEditDocuments from './hooks/useEditDocuments'
import { FormDocuments } from './form/formDocuments'

export const AdminEditDocuments = () => {
  const { loading, formContext, setFormContext, handleEditDocuments } = useEditDocuments()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      <Form.Root
        action={() => {
          handleEditDocuments()
        }}
      >
        <Column.Root>
          <Column.Content>
            <p className="subtitle is-size-3">Documento</p>
          </Column.Content>
        </Column.Root>
        <FormDocuments loading={loading} values={formContext} setValues={setFormContext} disabledList={{}} />
      </Form.Root>
    </Page.Section>
  )
}
